//import {galleryData} from "../store/GalleryData"
import request from '../utils/request.js';
import image from './image';
import { IListResult, IResult } from '../global';
const wxuser = {
  inviteUsers: (page: number = 1, page_size: number = 20, galleryId: string | number) => {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url:'/api/v2/user/inviteuser/' + galleryId,
        method:'get',
        data:{
          page,
          page_size
        }
      }).then(res=>{
        resolve(res)
      }).catch(reject);
    })
  },
  loveImages: (page: number = 1) => {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url: '/api/v2/user/loveimages',
        method: 'get',
        data: {
          page
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  spliceImages: (page: number = 1) => {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url: '/api/v2/user/spliceimages',
        method: 'get',
        data: {
          page
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  payedImages: (page: number = 1) => {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url: '/api/v2/user/payedimages',
        method: 'get',
        data: {
          page,
          page_size:30
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  visitedGallery: (page: number = 1) => {
    return new Promise<IListResult>((resolve, reject) => {
      request({
        url: '/api/v2/user/visithistory',
        method: 'get',
        data: {
          page
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  getLastVisit: ()=>{
    return new Promise<IResult>((resolve, reject)=>{
      request({
        url:request.domain = '/api/v2/user/lastvisithistory',
        method:'get',
        headers:{
          Authorization: request.token
        }
      }).then(res=>{
        resolve(res);
      }).catch(reject)
    })
  },
  visited: (galleryid: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url:
          request.domain + '/api/v2/gallery_visit/link/' + galleryid + '/add',
        method: 'post',
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    }),
  //id  图片id,  galleryid 相册id, path 图片地址
  sendLove: function({
    id,
    galleryid,
    path
  }: {
    id: number;
    galleryid: number;
    path: string;
  }) {
    return new Promise((resolve, reject) => {
      if (!(id && galleryid && path)) {
        console.error('数据异常，请检查数据', id, galleryid, path);
        reject();
      }
      request({
        url: '/api/v2/userimage/love',
        method: 'post',
        data: {
          id,
          galleryid,
          path
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  removeVisited: function(id: number) {
    if (!id) {
      console.error('参数异常');
      return;
    }
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/usergallery/remove',
        method: 'post',
        data: {
          id
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceUserInfo: function(opt: any) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/userinfo',
        method: 'get',
        data: opt,
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceDestroyInfo: ()=>{
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face/destroymyself',
        method: 'post',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceUpdateInfo: function({ image }: any) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face/updateinfo',
        method: 'post',
        data: {
          image
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceFollow: function(obj: any) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face3/follow',
        method: 'post',
        data: obj,
        headers: {
          Authorization: request.token,
        },
      })
        .then((res) => {
          /**
           * 错误情况:
           * {"code":2000203,"messge":"您的好友数量已达上限（50个）"}
           * 
           * 成功情况:
           * {
           *    "code": 200,
           *    "data": {
           *        "id": 32487,
           *        "userid": "ov02B05DmKumambBSFXM9O96GJBk",
           *        "faceurl": "//image4.jimage.cn/source/10d9e40f07130d1f4f7d380f469706441.jpg?x-oss-process=image%2Fresize%2Cm_lfit%2Cw_1920%2Climit_0%2Fcrop%2Cx_547%2Cy_857%2Cw_466%2Ch_466%2Cg_nw%2Fformat%2Cwebp",
           *        "personid": "4901755",
           *        "name": "关注好友",
           *        "CreatedAt": "2026-01-23 15:36:48",
           *        "UpdatedAt": "2026-01-23 15:36:48",
           *        "DeletedAt": null
           *    },
           *    "messge": "success"
           *  } 
           */
          if (res.code === 200) {
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch(reject);
    });
  },
  faceUnfollow: function({ personid = 0 }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face3/unfollow',
        method: 'post',
        data: {
          personid
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceGallery: function(opt: any) {
    //47

    return new Promise((resolve, reject) => {
      request({
        url: '/api/face/gallery',
        method: 'get',
        data: opt
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceMaybe: function(imageid: number) {
    //1346211
    //
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face3/maybe',
        method: 'get',
        data: {
          imageid
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceHide: function({ imageid = 0, personid = 0 }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/face/hide',
        method: 'post',
        data: {
          imageid,
          personid
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },

  findPeople: function(opt: any) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face3/findpeople',
        method: 'post',
        data: opt,
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },

  faceEditBuddy: function({ personid = 0, name = '' }) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face/editfollow',
        method: 'post',
        data: {
          name,
          personid
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  faceIsFriend: function(personid: number) {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/face/isfriend',
        method: 'get',
        data: {
          personid
        },
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  like: function(galleryid = '', imageid = '') {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/images/user/loved',
        method: 'get',
        data: {
          galleryid,
          imageid
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  session: function() {
    return new Promise((resolve, reject) => {
      request({
        url: '/session.js',
        method: 'get',
        credentials: 'include'
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  currentPayedImages: function(gallery_id: string | number , page:number = 1) {
    return new Promise<IListResult>((resolve, reject)=>{
      request({
        url:`/api/v2/pay/getdownimglist`,
        method:'get',
        credentials: 'include',
        headers: {
          Authorization: request.token
        },
        data:{
          page,
          gallery_id
        }
      }).then(resolve).catch(reject);
    })
  },
  payToImage: function(gallery_id:string | number, goods_id:string | number, link_id: string, imgids: any[]) {
    return new Promise<IResult>((resolve, reject)=>{
      request({
        url:`/api/v2/pay/predownimg`,
        method:'post',
        credentials: 'include',
        headers: {
          Authorization: request.token
        },
        data:{
          gallery_id,
          goods_id,
          link_id,
          imgids
        }
      }).then(resolve).catch(reject);
    });
  }
};

export default wxuser;
